import initialState from './initialState'
import reducer from './reducers'

import {
  initialize,
  permitCreate,
  permitRead,
  permitUpdate,
  permitDelete,
  createInform,
  createSuccess,
  createFail,
  readInform,
  readSuccess,
  readFail,
  updateInform,
  updateSuccess,
  updateFail,
  deleteInform,
  deleteSuccess,
  deleteFail,
} from './actions'

const composeBindActionCreator = function (dispatch) {
  return function (actionCreator) {
    return function (payload) {
      dispatch(actionCreator(payload))
    }
  }
}

export default function createState () {
  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.')
  }

  let currentState = initialState()

  function get () {
    return currentState
  }

  function dispatch (action) {
    currentState = reducer(currentState, action)

    return get()
  }

  function permissions () {
    return get().permit
  }

  const bindActionCreator = composeBindActionCreator(dispatch)

  return {
    dispatch,
    permissions,
    get,

    // Actions
    initialize: bindActionCreator(initialize),
    permitCreate: bindActionCreator(permitCreate),
    permitRead: bindActionCreator(permitRead),
    permitUpdate: bindActionCreator(permitUpdate),
    permitDelete: bindActionCreator(permitDelete),
    createInform: bindActionCreator(createInform),
    createSuccess: bindActionCreator(createSuccess),
    createFail: bindActionCreator(createFail),
    readInform: bindActionCreator(readInform),
    readSuccess: bindActionCreator(readSuccess),
    readFail: bindActionCreator(readFail),
    updateInform: bindActionCreator(updateInform),
    updateSuccess: bindActionCreator(updateSuccess),
    updateFail: bindActionCreator(updateFail),
    deleteInform: bindActionCreator(deleteInform),
    deleteSuccess: bindActionCreator(deleteSuccess),
    deleteFail: bindActionCreator(deleteFail),
  }
}
